module.exports = "/static-assets/_next/static/images/games-logo-673462783c8d1c1f2945840d62e4258c.svg";